import { adminApi } from '@client/auth';

export function fetchCampaignNotifications(pageSize, nextPage) {
  return adminApi.get(`/notifications?pageSize=${pageSize}&page=${nextPage}`);
}

export function putMarkAsRead(notificationIds) {
  return adminApi.put('/notifications/mark-as-read', {
    markAll: notificationIds === undefined,
    notificationIds: [notificationIds],
  });
}
